import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { PlayAudioButton } from 'components/flink-play';
import classes from './Item.module.scss';
//import { s3bucketPublicURL } from 'config';
import { s3bucketPublicURL, uploadsURL, activitiesKey } from 'config';

//const Item = ({ data, style = {}, contentFolder, className }) => {
/*const Item = ({ data, style = {}, contentFolder, className, activity, solutionLocale }) => {  
  const { text, audio, audioPath } = data;
  //const contentPath = audioPath || `${s3bucketPublicURL}/${contentFolder}/gamedata/`;
  const thisVersion = activity ? activity.currentLanguageVersion 
  : {version: 'immersion', locale: solutionLocale.code};
const versionType = thisVersion && thisVersion.version && thisVersion.locale 
  ? `${thisVersion.version}_${thisVersion.locale}` : "";
const contentPath = audioPath || 
(versionType ? `${uploadsURL}/${activitiesKey}/${activity._id}/languageVersionData/${versionType}/` 
  : `${s3bucketPublicURL}/${contentFolder}/gamedata/`);

  const textClasses = classnames(classes.textValue, {
    [classes.medium]: text?.length >= 50 && text?.length < 100,
    [classes.long]: text?.length >= 100,
  });

  console.log('Item activity:', activity);  
  return (
    <div
      className={classnames(classes.item + ' ' + className, {
        [classes.withAudio]: !!audio
      })}
      style={style}
    >
      {audio && (
        <PlayAudioButton
          url={contentPath + audio}
          className={classes.playAudioBtnSmall}
        />
      )}

      {text ? <span className={textClasses}>{text}</span> : null}
    </div>
  );
};*/

const Item = ({ data, style = {}, contentFolder, className, activity, solutionLocale }) => {
  const { text, audio, audioPath } = data;

  /*const locale = activity?.monolingual ? '' 
      : (activity?.currentLanguageVersion?.locale 
          ? activity.currentLanguageVersion.locale
          : solutionLocale?.code ? solutionLocale.code : '');*/
  
  const locale = activity?.monolingual ? '' : (window.location.href.indexOf('edit-activities') !== -1 &&
    activity?.currentLanguageVersion?.locale 
    ? activity.currentLanguageVersion.locale
    : solutionLocale?.code ? solutionLocale.code : '');
        

  const versionType = (!locale || locale === 'en') ? "" : `immersion_${locale}`;

  const contentPath = audioPath ||
      (versionType
          ? `${uploadsURL}/${activitiesKey}/${activity._id}/languageVersionData/${versionType}/`
          : `${s3bucketPublicURL}/${contentFolder}/gamedata/`);

  const textClasses = classnames(classes.textValue, {
      [classes.medium]: text?.length >= 50 && text?.length < 100,
      [classes.long]: text?.length >= 100,
  });

  console.log('Item versionType:', [versionType,locale,activity]);

  return (
      <div
          className={classnames(classes.item + ' ' + className, {
              [classes.withAudio]: !!audio
          })}
          style={style}
      >
          {audio && (
              <PlayAudioButton
                  url={contentPath + audio}
                  className={classes.playAudioBtnSmall}
              />
          )}

          {text ? <span className={textClasses}>{text}</span> : null}
      </div>
  );
};


Item.propTypes = {
  text: PropTypes.string,
  contentFolder: PropTypes.string.isRequired
};

//const mapStateToProps = ({ game }) => ({
//  contentFolder: game.currentActivity.activity.contentFolder
const mapStateToProps = ({ game, flinkPlay: { solutionLocale } }) => ({
  contentFolder: game.currentActivity.activity.contentFolder,
  activity: game.currentActivity.activity,
  solutionLocale: solutionLocale
});

export default connect(mapStateToProps)(Item);
